module.exports = __webpack_public_path__ + "static/media/dp-logo-new.84d6c2e5.png";